<template>
	<div>
		<aside v-if="!ready" class="app-loading">
			<p>Loading Nearest Locations...</p>
		</aside>
		<aside v-if="ready">
			<div class="form mb-4">
				<div class="content">
					<fieldset>
						<label>Enter Zip Code</label>
						<input v-model="searchString"
							   type="number"
							   max="99999"
							   min="0"
							   tabindex="1"
							   required
							   autofocus>
					</fieldset>
					<fieldset>
						<label>Search Within</label>
						<select v-model="searchRadius">
							<option value="5">5 Miles</option>
							<option value="20">20 Miles</option>
							<option value="50">50 Miles</option>
							<option value="100">100 Miles</option>
						</select>
						<button class="btn-beltone mt-2" @click="search()">
							<div v-show="loading" class="btn-spinner white">
								<div class="outer"><div class="inner"><span></span></div></div>
							</div>
							<span :class="{'hidden': loading}">Search</span>
						</button>
					</fieldset>
				</div>
			</div>
			<view-basic v-if="showMap !== 'True'"></view-basic>
			<view-advanced ref="advanced" v-else :searchString="searchString" :searchRadius="searchRadius" :usingSearchString="usingSearchString"></view-advanced>
		</aside>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import EventBus from '../../js/eventBus'
	import Services from '../mixins/services';
	import ViewBasic from './../components/location-search/view-basic'
	import ViewAdvanced from './../components/location-search/view-advanced'

	export default {
		mixins: [Services],
		props: ['showMap'],
		components: {
			ViewBasic,
			ViewAdvanced
		},
		data: function () {
			return {
				ready: false,
				loading: false,
				searchString: "",
				searchRadius: 20,
				isInitialStateOrCityPageLoad: false,
				isStateOrCityPage: false,
				usingSearchString: false,
				queryParams: null
			}
		},
    computed: mapState({
			geoLocation: state => state.LocationSearch.geoLocation,
			searchResults: state => state.LocationSearch.searchResults,
			clientToken: state => state.ClientToken.clientToken,
		}),
		methods: {
			...mapActions('GoogleApi', { getIpLocation: 'getIpLocation' }),
			...mapActions('ClientToken', { getClientToken: 'getClientToken' }),
			...mapActions('LocationSearch', { updateGeoLocation: 'updateGeoLocation' }),
			...mapActions('LocationSearch', { getSearchResults: 'getSearchResults' }),
			...mapActions('LocationSearch', { resetResults: 'resetResults' }),
      setSearchResults(longitude, latitude, searchRadius) {
        this.getSearchResults({
          Longitude: longitude,
          Latitude: latitude,
          SearchRadius: searchRadius || this.queryParams.get('radius'),
          ZipCode: this.queryParams.get('zip'),
          PageSize: searchRadius ? this.showMap === 'True' ? 8 : 3 : 96,
          PageNumber: 0,
          ClientToken: this.clientToken,
          replaceData: true,
          State: this.queryParams.get('state'),
          ExcludeMilesAway: this.isStateOrCityPage,
					cb: () => {
            this.ready = true;
            setInterval(() => {
              let height = $('body').outerHeight(); // IMPORTANT: If body's height is set to 100% with CSS this will not work.
              parent.postMessage("resize::locationSearch" + height, "*");
            }, 1000);
          }
        })
			},
			setGeolocation(longitude, latitude) {
				this.updateGeoLocation({
					longitude: longitude,
					latitude: latitude,
				});
        this.setSearchResults(longitude, latitude, 20000);
			},
			async search() {
				if (this.searchString.length === 0 && this.state.length === 0) return;
				this.loading = true;
				this.usingSearchString = true;
				let isNum = /^\d+$/.test(this.searchString);
				this.resetResults();
				this.getSearchResults({
					SearchRadius: this.searchRadius,
					ZipCode: isNum ? this.searchString : null,
					City: isNum ? null : this.searchString,
					PageSize: this.showMap === 'True' ? 8 : 3,
					PageNumber: 0,
					ClientToken: this.clientToken,
					cb: () => {
						this.isInitialStateOrCityPageLoad = false;
						if (this.searchResults && this.showMap === 'True') {
							this.$refs.advanced.$refs.gMaps.searchLocations();
						}
						this.loading = false;
					}
				})
			},
		},
    mounted() {
			this.getClientToken({
				cb: () => {
					let useGeoLocation = true;
					this.queryParams = new URLSearchParams(window.location.search);
					this.isStateOrCityPage = (this.queryParams.get('zip') !== null && this.queryParams.get('radius') !== null) || this.queryParams.get('state') !== null;					
          if (this.isStateOrCityPage) {
						this.isInitialStateOrCityPageLoad = true;
						this.setSearchResults();
						useGeoLocation = false;
					}

          let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (isSafari) {
            this.getIpLocation({
							cb: (res) => {
								if (useGeoLocation) {
									this.setGeolocation(res.lng, res.lat);
								}
              }
            })
          } else {
            this.getIpLocation({
							cb: (res) => {
								if (useGeoLocation) {
									this.setGeolocation(res.lng, res.lat);
								}
              }
            });
						navigator.geolocation.getCurrentPosition((position) => {
							if (useGeoLocation) {
								this.setGeolocation(position.coords.longitude, position.coords.latitude);
							}
            });
          }
				}
			});
		}
  }
</script>
